import { appendInlineScript } from '../dom/appendInlineScript';
import { buildCookiebotGtmConsentBridgeScript } from '../cookiebot/cookiebotGtmConsentBridge';
import { GTM_POST_HYDRATION_SCRIPT_ELEMENT_ID } from './gtmConsts';
import {
  buildGtmLoaderScript,
  type BuildGtmLoaderScriptOptions,
} from './gtmScriptBuilders';

export const appendGtmLoaderWithCookiebotConsentBridge = (
  options: BuildGtmLoaderScriptOptions,
): void => {
  appendInlineScript(
    GTM_POST_HYDRATION_SCRIPT_ELEMENT_ID,
    [
      buildGtmLoaderScript(options),
      buildCookiebotGtmConsentBridgeScript(),
    ].join('\n'),
  );
};
